import { Box } from "@mui/material"
import GoogleMapReact from 'google-map-react'
import { useStyles } from "./styles"
import { DestinationMapProps } from "./types"
import { Constants } from "../../../../../../../utils/constants";
import { MapMarkerDestination } from "../destinationMark";
import { MapPointDestination } from "../destinationPointMap";

export const DestinationMap = ({ destinationMark = [] }: DestinationMapProps) => {

    const fistCordinates = !!destinationMark.length ? { lat: destinationMark[0].lat, lng: destinationMark[0].long, } : Constants.mapDefault?.center;
    const styles = useStyles()

    return (
        <Box sx={styles.map}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: process.env.REACT_APP_MAP_APIKEY ?? '', }}
                defaultCenter={Constants.mapDefault?.center}
                center={fistCordinates}
                zoom={14}
                //onGoogleApiLoaded={handleApiLoaded}
                yesIWantToUseGoogleMapApiInternals
            >
                {destinationMark?.map((point, idx) => (
                    <div
                        key={`${point.id}-${idx}`}
                        lat={point.lat}
                        lng={point.long}
                    >
                        <MapMarkerDestination
                            {...point}
                            Node={() => (
                                <MapPointDestination
                                    name={point.name}
                                />
                            )}
                        />
                    </div>

                ))}
            </GoogleMapReact>
        </Box>
    )
}